/** The customer-facing catalogue. Persisted billing history is not a catalogue. */
export const PUBLIC_PLAN_IDS = ["free", "cust"] as const;
export const ENTERPRISE_TRIAL_URL = "https://nosible.com/start-trial";
export const ENTERPRISE_CHECKOUT_MESSAGE = `Enterprise access starts at ${ENTERPRISE_TRIAL_URL}. Self-service paid checkout is not available.`;

export function isPublicPlanId(id: string): boolean {
  return PUBLIC_PLAN_IDS.some((supported) => supported === id);
}

export function publicPlanName(id: string): "Free" | "Enterprise" {
  if (!isPublicPlanId(id)) throw new Error("This plan is not in the public catalogue.");
  return id === "free" ? "Free" : "Enterprise";
}

export function canActivateFreePlan(plan: {id: string; active: boolean; monthlyPriceCents: number}): boolean {
  return plan.id === "free" && plan.active && plan.monthlyPriceCents === 0;
}

/** Only supported, active products may be offered, regardless of stale DB rows. */
export function availablePublicPlans<T extends {id: string; name: string; active: boolean}>(
  plans: T[], allowFree = true,
): T[] {
  return plans
    .filter((plan) => plan.active && isPublicPlanId(plan.id) && (allowFree || plan.id !== "free"))
    .map((plan) => ({...plan, name: publicPlanName(plan.id)}));
}
